
import {
  ref,
  reactive,
  ComponentInternalInstance,
  getCurrentInstance,
} from "vue";
import { useRoute, useRouter} from "vue-router";
export default {
  props: {}, 
  
  setup(props: any) {
    const password = ref('');
    const username = ref('');
    // const passwordVerify = ref(true);
      const router = useRouter()
    const isShowPassword = ref(false);
    const isShowPWFn = () => {
      isShowPassword.value = !isShowPassword.value;
    }; 
    
    const goFPassword = () => {
      router.push('/findPwd')
    }; 
    return {
      isShowPassword,
      isShowPWFn,
      password,  
      username,
      goFPassword
    };
  },
};
